import { Box, Grid } from '@mui/material';
import React from 'react';

import {
  FHAntdDateTimePicker,
  FAntdTimePicker,
  FHButton,
} from '../../../base';
import { BackgroundTypes } from '../../../../constants';
import { applyTimeToDate, disabledFutureDate } from '../../../../helpers';
import { FORTA_WHITE } from '../../../../utils/colors';

import type { Moment } from 'moment';

interface AdminBackdateFormProps {
  visible: boolean;
  backdatedDate: Moment | null;
  onBackdatedDateChange: (value: Moment) => void;
  onBackdateClick: () => void;
}

function AdminBackdateForm({
  visible,
  backdatedDate,
  onBackdatedDateChange,
  onBackdateClick,
}: AdminBackdateFormProps) {
  if (!visible) return null;

  const handleDateChange = (value: Moment | null) => {
    if (value) onBackdatedDateChange(value);
  };

  const handleTimeChange = (value: Moment | null) => {
    if (value && backdatedDate) {
      onBackdatedDateChange(applyTimeToDate(backdatedDate, value));
    }
  };

  return (
    <Grid item xs={12} mt={2}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Box mr={3}>
          <FHAntdDateTimePicker
            format="MM/DD/YY"
            inputHeight={40}
            sx={{ boxShadow: 'none' }}
            BackgroundTypes={BackgroundTypes.Colored}
            inputReadOnly
            allowClear={false}
            value={backdatedDate}
            disabledDate={disabledFutureDate}
            onSelect={handleDateChange}
            onChange={handleDateChange}
          />
        </Box>
        <FAntdTimePicker
          inputHeight={40}
          style={{ boxShadow: 'none', backgroundColor: FORTA_WHITE }}
          format="h:mm A"
          allowClear={false}
          showNow
          use12Hours
          coloredBackground
          value={backdatedDate}
          onChange={handleTimeChange}
          onSelect={handleTimeChange}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', ml: 3 }}>
          <FHButton onClick={onBackdateClick}>
            Backdate Note
          </FHButton>
        </Box>
      </Box>
    </Grid>
  );
}

export default AdminBackdateForm;
